import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { WebServiceService } from '../../services/web-service.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { VlHttpService, VlDataService, HTTPAPIConfig, APIConfigMapping, isNullOrUndefined,appSettingService, ApiconfigService } from 'shared-library';
import { animate, style, transition, trigger } from '@angular/animations';
import { SIDENAV_DATA_MODULES } from '../../constants/side-nav.cnst';
import { pageTypeCnsts } from '../../constants/proj.cnst';
import { MatDialog } from '@angular/material/dialog';
import { webPublishAppComponent } from '../publish-app/publish-app/publish-app.component';

@Component({
  selector: 'lib-web-builder-home',
  templateUrl: './web-builder-home.component.html',
  styleUrls: ['./web-builder-home.component.scss'],
  animations: [
    trigger('sidenavFadInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-100px)' }),
        animate('200ms', style({ opacity: 1, transform: 'translateX(0px)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateX(0px)' }),
        animate('200ms', style({ opacity: 0, transform: 'translateX(-100px)' }))
      ])
    ]),
  ]
})
export class WebBuilderHomeComponent implements OnInit {
  displaySidenavContent!: boolean;
  displaySidenavContentList!: boolean;
  breadcrumbData: any
  pages1!: any;
  paramsData: any
  applicationId!: string;
  applicationType!:string;
  defaultPages: any;
  defPages:any=[];
  sideNavOptions = SIDENAV_DATA_MODULES;
  isWidthApplied:boolean = false;
  apiTab:boolean = false;
  constructor(
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private sharedService: WebServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private appSettingsService : appSettingService,
    private apiConfigService:ApiconfigService,
    public dialog: MatDialog
  ) {}

  async ngOnInit() {
    const params = this.route.snapshot.queryParams;
    this.applicationId = params?.['id']
    this.applicationType = params?.['applicationType']
    this.route.queryParams.subscribe((params: Params) => {
      this.applicationId=params?.['id']
      this.paramsData = params;
    })
    this.sharedService.selectedOption$.subscribe(option => {
      this.displaySidenavContent = false;
      this.displaySidenavContent = option.isActive;
      
    });
    this.viewSetters()
    await this.apiConfigService.getAllApisResquest();
    const themesSubscribption: any = this.sharedService.themesObj.subscribe((data: any) => {
      this.updateStyles(data.primaryColor, data.secondaryColor, data.defaultBackgroundColor, data.themeName)
    })
  }

  viewSetters(){
    this.getApplicationById(this.applicationId);

    this.sharedService.selectedOption$.subscribe((option) => {
      option?.label == this.sideNavOptions.metrics ? this.isWidthApplied = true : this.isWidthApplied = false;
      this.apiTab = option?.label === this.sideNavOptions.api;
      this.displaySidenavContent = false;
      this.displaySidenavContent = option.isActive;
      if(option?.label == this.sideNavOptions.publish){this.openPublishPopUp()}
    });
    this.sharedService.sidenavContentlistSubject$.subscribe((options) => {
      this.displaySidenavContentList = false;
      this.displaySidenavContentList = options.isActive;
    });
    this.breadcrumbData = JSON.parse(localStorage.getItem('webMeta') ?? '');
  }

  onClickBreadcrumb(name: any) {
    if (name == 'home') {
      this.router.navigate(['home'])
    } else {
      this.router.navigate(['home', 'applications'], { queryParams: { id: this.breadcrumbData?.id, projectName: this.breadcrumbData?.projectName } })
    }
  }

  pageDetailsSetter(pageId:any) {
    const currentParams = { ...this.route.snapshot.queryParams };
    currentParams["pageId"] = pageId;
    this.sharedService.setSelectedOption('Pages',true);
    this.router.navigate([], {  
      relativeTo: this.route,
      queryParams: currentParams,
      queryParamsHandling: "merge",
    });
  }


  getApplicationById(id:string){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATION']);
    apiConfig.postData = {
      id: id
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.applicationId = data.application_id;
        this.appSettingsService.setApplicationDetails(data);
        this.sharedService.setApplicationDataById(data);
      },
      error: (err: any) => {
      },
      complete:() => {
        this.getAllPages(this.applicationId)
        this.getThemeData();
      }
    })
  }

  getAllPages(applicationId:string){
    this.sharedService.getAllPages(applicationId).subscribe({
      next: (pages:any) => {
        this.sharedService.setAllPages(pages);
        if(!this.paramsData?.['pageId'] && pages.length > 0){
          this.pageDetailsSetter(pages[0].pageId);
        }else if(this.paramsData?.['pageId']){
          this.pageDetailsSetter(this.paramsData['pageId']);
        }
      },
      error:(err:any) => {
      },
      complete:() => {
      }
    })
  }

  getThemeData(){
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_THEME_BYID']);
    apiConfig.postData = {
      "id": this.appSettingsService.getApplicationDetails().theme_id,
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
    next: (data: any) => {
      this.sharedService.setWholeTheme(data);
    },
    error: (err: any) => {
    }
    })
  }

  updateStyles(primary: any, secondary: any, background: any, themeType: string) {
    const styleTag: HTMLStyleElement = this.renderer.createElement('style');
    const styleContent: string = themeType.toLocaleLowerCase().includes('dark') ? `:root,:host {--md-sys-color-primary:${primary};
    --md-sys-color-on-primary:${secondary};--md-sys-color-primary-container:rgb(0 0 230);--md-sys-color-on-primary-container:rgb(164 170 255);--md-sys-color-primary-fixed:rgb(224 224 255);--md-sys-color-on-primary-fixed:rgb(0 0 110);--md-sys-color-primary-fixed-dim:rgb(190 194 255);--md-sys-color-on-primary-fixed-variant:rgb(0 0 239);--md-sys-color-secondary:rgb(190 194 255);--md-sys-color-on-secondary:rgb(25 31 137);--md-sys-color-secondary-container:rgb(44 50 152);--md-sys-color-on-secondary-container:rgb(157 164 255);--md-sys-color-secondary-fixed:rgb(224 224 255);--md-sys-color-on-secondary-fixed:rgb(0 0 110);--md-sys-color-secondary-fixed-dim:rgb(190 194 255);--md-sys-color-on-secondary-fixed-variant:rgb(51 58 159);--md-sys-color-tertiary:rgb(255 180 169);--md-sys-color-on-tertiary:rgb(105 0 1);--md-sys-color-tertiary-container:rgb(140 0 2);--md-sys-color-on-tertiary-container:rgb(255 145 129);--md-sys-color-tertiary-fixed:rgb(255 218 213);--md-sys-color-on-tertiary-fixed:rgb(65 0 0);--md-sys-color-tertiary-fixed-dim:rgb(255 180 169);--md-sys-color-on-tertiary-fixed-variant:rgb(147 0 2);--md-sys-color-error:rgb(255 180 171);--md-sys-color-on-error:rgb(105 0 5);--md-sys-color-error-container:rgb(147 0 10);--md-sys-color-on-error-container:rgb(255 218 214);--md-sys-color-outline:rgb(115 115 135);--md-sys-color-background:rgb(18 18 29);--md-sys-color-on-background:rgb(227 225 241);--md-sys-color-surface:rgb(18 18 29);--md-sys-color-on-surface:rgb(227 225 241);--md-sys-color-surface-variant:rgb(69 69 88);--md-sys-color-on-surface-variant:rgb(197 196 219);--md-sys-color-inverse-surface:rgb(227 225 241);--md-sys-color-inverse-on-surface:rgb(47 47 59);--md-sys-color-inverse-primary:rgb(52 61 255);--md-sys-color-shadow:rgb(0 0 0);--md-sys-color-surface-tint:rgb(190 194 255);--md-sys-color-outline-variant:rgb(69 69 88);--md-sys-color-scrim:rgb(0 0 0);--md-sys-color-surface-container-highest:rgb(51 52 64);--md-sys-color-surface-container-high:rgb(41 41 53);--md-sys-color-surface-container:rgb(30 31 42);--md-sys-color-surface-container-low:rgb(26 27 38);--md-sys-color-surface-container-lowest:rgb(13 13 24);--md-sys-color-surface-bright:rgb(56 56 68);--md-sys-color-surface-dim:rgb(18 18 29);}` : `
      :root,
      :host {
      --md-sys-color-primary:${primary};
      --md-sys-color-on-primary:${secondary};
      --md-sys-color-primary-container:rgb(224 224 255);
      --md-sys-color-on-primary-container:rgb(14 18 83);
      --md-sys-color-primary-fixed:rgb(224 224 255);
      --md-sys-color-on-primary-fixed:rgb(14 18 83);
      --md-sys-color-primary-fixed-dim:rgb(190 194 255);
      --md-sys-color-on-primary-fixed-variant:rgb(60 65 128);--md-sys-color-secondary:rgb(92 93 114);--md-sys-color-on-secondary:rgb(255 255 255);--md-sys-color-secondary-container:rgb(225 224 249);--md-sys-color-on-secondary-container:rgb(25 26 44);--md-sys-color-secondary-fixed:rgb(225 224 249);--md-sys-color-on-secondary-fixed:rgb(25 26 44);--md-sys-color-secondary-fixed-dim:rgb(197 196 221);--md-sys-color-on-secondary-fixed-variant:rgb(68 69 89);--md-sys-color-tertiary:rgb(120 83 107);--md-sys-color-on-tertiary:rgb(255 255 255);--md-sys-color-tertiary-container:rgb(255 216 238);--md-sys-color-on-tertiary-container:rgb(46 17 38);--md-sys-color-tertiary-fixed:rgb(255 216 238);--md-sys-color-on-tertiary-fixed:rgb(46 17 38);--md-sys-color-tertiary-fixed-dim:rgb(232 185 213);--md-sys-color-on-tertiary-fixed-variant:rgb(94 60 82);--md-sys-color-error:rgb(186 26 26);--md-sys-color-on-error:rgb(255 255 255);--md-sys-color-error-container:rgb(255 218 214);--md-sys-color-on-error-container:rgb(65 0 2);--md-sys-color-outline:rgb(116 115 125);--md-sys-color-background:rgb(251 248 255);--md-sys-color-on-background:rgb(27 27 33);--md-sys-color-surface:rgb(251 248 255);--md-sys-color-on-surface:rgb(27 27 33);--md-sys-color-surface-variant:rgb(228 225 236);--md-sys-color-on-surface-variant:rgb(70 70 79);--md-sys-color-inverse-surface:rgb(48 48 54);--md-sys-color-inverse-on-surface:rgb(242 239 247);--md-sys-color-inverse-primary:rgb(190 194 255);--md-sys-color-shadow:rgb(0 0 0);--md-sys-color-surface-tint:rgb(84 89 153);--md-sys-color-outline-variant:rgb(199 197 208);--md-sys-color-scrim:rgb(0 0 0);

      --md-sys-color-surface-container-high:rgb(234 231 239);--md-sys-color-surface-container:rgb(240 236 244);--md-sys-color-surface-container-low:rgb(245 242 250);--md-sys-color-surface-container-lowest:rgb(255 255 255);--md-sys-color-surface-bright:rgb(251 248 255);--md-sys-color-surface-dim:rgb(219 217 224);
      }
    `;
    // --md-sys-color-surface-container-highest:${secondary};

    this.renderer.appendChild(styleTag, this.renderer.createText(styleContent));

    // Remove any existing style tags
    const existingStyles: NodeListOf<HTMLStyleElement> = this.el.nativeElement.querySelectorAll('style');
    existingStyles.forEach(style => this.renderer.removeChild(this.el.nativeElement, style));

    // Append the new style tag to the component's element
    this.renderer.appendChild(this.el.nativeElement, styleTag);
  }

  onCanvasClick(event: MouseEvent): void {
    let obj = this.sharedService.getSelectedOption();
    let selectedpage = this.sharedService.getSelectedPage();
    let objOptions = this.sharedService.getSidenavContentlist();
    if(obj.isActive ){
      if(obj.label == 'Pages' && selectedpage.pageType!='PreviewPage'){
        this.sharedService.setSidenavContentlistOption('addComponent', !objOptions.isActive);
      }
    }else{
      this.sharedService.setSelectedOption('Pages',true);
      this.sharedService.setSidenavContentlistOption('addComponent',true);
    }
  }

  onComponentClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  openPublishPopUp(){
    const dialogRef = this.dialog.open(webPublishAppComponent, {
      disableClose: true
    });
  }

}
